import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=55e25166&scoped=true"
var script = {}
import style0 from "./Heart.vue?vue&type=style&index=0&id=55e25166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e25166",
  null
  
)

export default component.exports